module.exports = __webpack_public_path__ + "f27536c47e3311cd546842dd8f4c60ba.png";